import { EventEmitter, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { IdexService } from '../../idex.service';
import { Message } from './notification-helper';
import { Observable, Subscription } from 'rxjs';
import { webSocket } from 'rxjs/webSocket';

declare const notifyService: string;
declare const webSocketUrl: string;

const APP_NAME = 'zdox';

@Injectable({ providedIn: 'root' })
export class NotificationService {
   messageArrived = new EventEmitter<Message>();
   private subscription?: Subscription;
   private reconnectTimeout = 300000;

   constructor(private service: IdexService) {}

   connect(): Observable<number> {
      this.subscription = this.connectWebSocket();
      return new Observable<number>(observer => {
         this.service.get(`${notifyService}/news`, this.createHttpOptions())
            .subscribe({
               next: info => {
                  this.reconnectTimeout = info.timeout;
                  observer.next(info.newMessages);
                  observer.complete();
               },
               error: e => observer.error(e)
            });
      });
   }

   disconnect(): void {
      this.subscription?.unsubscribe();
   }

   list(page: number, size: number): Observable<any> {
      const url = `${notifyService}/list?page=${page}&size=${size}`;
      return this.service.get(url, this.createHttpOptions());
   }

   read(id?: number): Observable<any> {
      let url = `${notifyService}/read`;
      if (id) {
         url += `?id=${id}`;
      }
      return this.service.put(url, undefined, this.createHttpOptions());
   }

   seen(): Observable<any> {
      const url = `${notifyService}/seen`;
      return this.service.post(url, undefined, this.createHttpOptions());
   }

   private createHttpOptions(): any {
      const headers = new HttpHeaders({
         'Content-Type': 'application/json',
         'X-Auth-Token': this.service.user.token,
         'X-Application': APP_NAME
      });
      return { headers };
   }

   private connectWebSocket(): Subscription {
      const subject = webSocket({
         url: webSocketUrl,
         binaryType: 'arraybuffer',
         deserializer: (e: MessageEvent) => {
            const msg = new TextDecoder().decode(e.data);
            return JSON.parse(msg);
         },
         closeObserver: {
            next: (e: CloseEvent) => {
               this.subscription?.unsubscribe();
               if (e.code !== 1000) {
                  setTimeout(() => this.subscription = this.connectWebSocket(), this.reconnectTimeout);
               }
            }
         }
      });
      return subject.multiplex(() => ({ appName: APP_NAME, token: this.service.user?.token }), () => ({ /*empty*/ }), msg => !!msg.id)
         .subscribe(msg => this.messageArrived.emit(msg));
   }
}
